import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hideEventShareModal } from 'src/actions/frontend'
import HobnobModal from 'src/components/common/HobnobModal'
import SvgIcon from 'src/components/common/SvgIcon'
import ShareFacebookIcon from 'src/assets/icons/icons8-facebook-circled.svg'
import ShareEmailIcon from 'src/assets/icons/icons8-circle-envelop.svg'
import ShareTwitterIcon from 'src/assets/icons/icons8-twitter-circled.svg'
import PropTypes from 'prop-types'
import { eventSelector, hostSelector, isHostSelector } from 'src/selectors'
import dateformat from 'dateformat'
import { mailtoLink, twitterLink, facebookLink } from 'services/share'
import CloneHostIcon from 'assets/icons/ico-clone-host.png'

import styles from './event-share-modal.scss'

class EventShareModal extends Component {
  _shareSubject(name) {
    const { event } = this.props

    return event.event_type === 'event' ? `You're invited to ${name}` : `Announcing: ${name}`
  }

  _twitterLink() {
    const { event } = this.props
    const params = {
      subject: this._shareSubject(event.name) + '!',
      url: event.twitter_share_url
    }
    return twitterLink(params)
  }

  _facebookLink() {
    const { event } = this.props

    const params = {
      href: event.facebook_share_url,
      redirect_uri: event.url
    }
    return facebookLink(params)
  }

  _mailtoLink() {
    const { event, host } = this.props
    let body = ''
    if (event.event_type === 'event') {
      body = `Can you make it to ${event.name}`

      if (event.starts_at) {
        const formattedDate = dateformat(event.starts_at, 'dddd, mmmm dS')
        body += ` on ${formattedDate}`
      }
      body += `?\n\n${event.email_share_url}`
    } else {
      body = 'Find out more details below!'
      if (host) {
        body += `\n\nFrom: ${host.first_name} ${host.last_name}`
      }
      body += `\n\n${event.email_share_url}`
    }

    const params = {
      subject:
        event.event_type === 'event'
          ? `You're invited to ${event.name}`
          : `We’re sharing the news with you about ${event.name}`,
      body
    }

    return mailtoLink(params)
  }

  handleTrack = type => {
    const { isHost } = this.props
    if (!isHost) {
      return
    }

    if (type === 'email') {
      window.mixpanel.track('Email Client Launched (Web)')
    } else if (type === 'facebook') {
      window.mixpanel.track('Facebook Client Launched (Web)')
      window.mixpanel.track('Social Channel Client Launched (Web)')
    } else if (type === 'twitter') {
      window.mixpanel.track('Twitter Client Launched (Web)')
      window.mixpanel.track('Social Channel Client Launched (Web)')
    }
  }

  handleCopyLink = () => {
    window.mixpanel.track('Link Copied (Web)')
    navigator.clipboard.writeText(this.props.event.url)
    setTimeout(() => {
      alert('Copied! 🎉')
    }, 300)
  }

  render() {
    const { visible, onHideEventShareModal, event } = this.props

    return (
      <HobnobModal show={visible} onClose={() => onHideEventShareModal()}>
        <div className={styles['event-share-container']}>
          <div className={styles['title']}>share your event</div>
          <div className={styles['description']}>
            Guests will add themselves to the Guest List at no extra cost! 💬 💌 📣
          </div>
          {/* <div className={styles['subtitle']}>Click to copy the public Event Link</div> */}
          <div className={styles['input-wrapper']} onClick={this.handleCopyLink}>
            <span>{event.url.substring(8)}</span>
            <img src={CloneHostIcon} width="30" />
          </div>
          <div className={styles['or-text']}>or</div>
          <a
            className={styles['input-wrapper']}
            href={this._facebookLink()}
            target="_blank"
            onClick={() => this.handleTrack('facebook')}
          >
            <span>Facebook</span>
            <SvgIcon icon={ShareFacebookIcon} className={styles['icon']} />
          </a>
          <a
            className={styles['input-wrapper']}
            href={this._mailtoLink()}
            target="_blank"
            onClick={() => this.handleTrack('email')}
          >
            <span>Email</span>
            <SvgIcon icon={ShareEmailIcon} className={styles['icon']} />
          </a>
          <a
            className={styles['input-wrapper']}
            href={this._twitterLink()}
            target="_blank"
            onClick={() => this.handleTrack('twitter')}
          >
            <span>Twitter</span>
            <SvgIcon icon={ShareTwitterIcon} className={styles['icon']} />
          </a>
        </div>
      </HobnobModal>
    )
  }
}

EventShareModal.propTypes = {
  onHideEventShareModal: PropTypes.func,
  visible: PropTypes.bool,
  event: PropTypes.object,
  host: PropTypes.object,
  isHost: PropTypes.bool
}

function mapStateToProps(state) {
  return {
    visible: state.frontend.eventShareModal,
    event: eventSelector(state),
    host: hostSelector(state),
    isHost: isHostSelector(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onHideEventShareModal: () => dispatch(hideEventShareModal())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventShareModal)



// WEBPACK FOOTER //
// ./src/components/details/EventShareModal/EventShareModal.jsx